function activateOptimizely() {
  window.optimizely = window.optimizely || [];
  window.optimizely.push({
    type: 'activate',
  });
}

function setUserAttributes(userAttributes: Record<string, unknown>) {
  window.optimizely = window.optimizely || [];
  window.optimizely.push({
    type: 'user',
    attributes: userAttributes,
  });
}

function flushOptimizelyWebQueue() {
  const queuedEvents = window.__optimizelyWebQueue || [];

  if (queuedEvents.length === 0) {
    return;
  }

  queuedEvents.forEach(({ payload }) => {
    const hasEventAlready = window?.dataLayer?.find(
      (item) =>
        item.event === 'campaign-decided' &&
        item['optimizely-dimension-value'] === payload['optimizely-dimension-value'] &&
        item['optimizely-dimension-number'] === payload['optimizely-dimension-number'],
    );

    if (hasEventAlready) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  });

  window.__optimizelyWebQueue = [];
}

export default defineNuxtPlugin((nuxtApp) => {
  const { optimizelyWebDisabled } = useOptimizelyState();

  if (optimizelyWebDisabled) {
    return;
  }

  onNuxtReady(() => {
    // Optimizely web experiments run as early as possible on a page to prevent the flash of control variation
    // This means that decision events are emitted by Optimizely before the Nuxt app is ready.
    // This means that Optimzely campaign-decided events are added to the data layer before other events like pageview.
    // This can cause issues with reporting and analytics.
    // To avoid this, until the Nuxt app is ready, we queue the events and flush them after the Nuxt app is ready.
    window.__tappNuxtReady = true;

    flushOptimizelyWebQueue();
  });

  nuxtApp.hook('page:finish', () => {
    // No need to activate web experiment on initial page load
    if (nuxtApp.isHydrating) {
      return;
    }

    // Ensure that the latest user attributes are set before activating the web experiment
    setUserAttributes(useUserAttributes());

    // Activate web experiment on SPA navigation
    activateOptimizely();
  });
});
